import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import {  TipologiaFase } from '../models';


class DataTablesResponse {
    data: TipologiaFase[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class TipologiaFaseService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}TipologieFasi/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<TipologiaFase[]>(
            `${this.apiUrl}`
        );
    }
    insert(s: TipologiaFase) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: TipologiaFase) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:TipologiaFase){
        if (s.id)return this.update(s);
        return this.insert(s);
    }

    getTipologieFasiColori() {
        return this.http.get<any>(
            `${this.apiUrl}colors`
        );
    }
    saveTipologieFaseColori(items:any[]){
        return this.http.put<any>(`${this.apiUrl}colors`,items);
    }

}
